import React from 'react';
// eslint-disable-next-line no-restricted-imports -- v5 form stack, migrate to v7 (DX-194)
import * as yup from 'yup-legacy';
import { Form } from '../../../../components/form/Form';
import { Input } from '../../../../components/form/Input';
import SubmitButton from '../../../../components/form/SubmitButton';
import { useTranslation } from 'react-i18next';
import { useForgotPasswordMutation } from '../../__generated__/graphql';
import { Redirect, useHistory } from 'react-router-dom';
import { routes } from '../../routes';
import { useMutationErrorHandler } from '../../../../hooks/useMutationErrorHandler';
import { LoginHistoryLocationState } from '../Login/LoginPasswordFormCommon';
import { isSharedHubDomain } from '../../sharedHubDomain';

type FormData = {
  email: string;
};

const defaultValues: FormData = {
  email: '',
};

const formSchema = yup.object().shape<FormData>({
  email: yup.string().required().email(),
});

const ForgotPassword: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();
  const history = useHistory<LoginHistoryLocationState>();
  const [forgotPassword] = useForgotPasswordMutation();
  const errorHandler = useMutationErrorHandler();
  const onSubmit = async ({ email }: FormData) => {
    // instanceName is null: on web the server scopes the reset to the visited
    // subdomain via the request host, so we don't need to send it explicitly.
    await forgotPassword({
      variables: { input: { email, instanceName: null } },
    })
      .then(() =>
        history.push(routes.login.route.create({}), {
          alertMessage: 'forgot-password',
        }),
      )
      .catch(errorHandler);
  };

  // On the shared address the request host carries no tenant, so the server
  // couldn't scope the reset and a duplicated email could target the wrong
  // hub. Send the visitor to the company picker instead.
  if (isSharedHubDomain()) {
    return <Redirect to={routes.login.route.create({})} />;
  }

  return (
    <>
      <h1 className="display-4 text-center mb-3">
        {t('forgotPassword.title')}
      </h1>
      <p className="text-muted text-center mb-5">
        {t('forgotPassword.subTitle')}
      </p>
      <Form
        onSubmit={onSubmit}
        validationSchema={formSchema}
        defaultValues={defaultValues}>
        <Input
          label={t('form.general.email.label')}
          placeholder={t('form.general.email.placeholder')}
          name="email"
          autoFocus
        />
        <SubmitButton block>{t('forgotPassword.button')}</SubmitButton>
      </Form>
    </>
  );
};

export default ForgotPassword;
